import { ref } from 'vue'

import type { BranchAddress } from '../BusinessDetails.types'

/**
 * Composable for managing branch addresses
 * Handles adding and removing branch address entries
 */
export function useBranchManagement() {
  const branches = ref<BranchAddress[]>([])

  const addBranch = () => {
    branches.value.push({
      street: '',
      street2: '',
      city: '',
      postalCode: '',
      country: '',
    })
  }

  const removeBranch = (index: number) => {
    branches.value.splice(index, 1)
  }

  return {
    branches,
    addBranch,
    removeBranch,
  }
}
